import { Action, Selector, State, StateContext } from "@ngxs/store";
import { DeviceDetectorService } from "ngx-device-detector";
import { GlobalStateModel } from "../../model/global.model";
import {
  setDefaultGlobal,
  setPrimaryColor,
  setTertiaryColor,
  setBarcodeType,
  incrementStep,
  decrementStep,
  setSTEP,
  setContentType,
  setLanguage,
  setFaceUrl,
  setBioSealUrl,
  setToken,
  setVerificationUrl,
  setupUseCase,
  setPhotoDisplay,
} from "../actions/global.action";
import { setSecondaryColor } from "../actions/global.action";
import { Injectable } from "@angular/core";
import { STEP } from "../../model/steps.model";
import { USECASE } from "../../model/usecase.model";

@State<GlobalStateModel>({
  name: "global",
  defaults: {
    primaryColor: "#ffffff",
    secondaryColor: "#374758",
    tertiaryColor: "#6baeed",
    token: null,
    step: STEP.UNDEFINED,
    contentType: false,
    photoDisplay: false,
    barcodeType: null,
    isPersonalDataLoaded: false,
    isDocumentDataLoaded: false,
    language: null,
    biosealUrl: null,
    faceUrl: null,
    verificationUrl: null,
    isMobile: false,
    useCase: USECASE.UNDEFINED,
  },
})
@Injectable({
  providedIn: "root",
})
export class GlobalState {
  constructor(private deviceService: DeviceDetectorService) { }
  @Selector()
  static getGlobal(state: GlobalStateModel) {
    return state;
  }
  @Selector()
  static getStep(state: GlobalStateModel) {
    return state.step;
  }
  @Selector()
  static getBarcodeType(state: GlobalStateModel) {
    return state.barcodeType;
  }
  @Selector()
  static getPrimaryColor(state: GlobalStateModel) {
    return state.primaryColor;
  }
  @Selector()
  static getTypeContent(state: GlobalStateModel) {
    return state.contentType;
  }
  @Selector()
  static getSecondaryColor(state: GlobalStateModel) {
    return state.secondaryColor;
  }
  @Selector()
  static getTertiaryColor(state: GlobalStateModel) {
    return state.tertiaryColor;
  }
  @Selector()
  static getLanguage(state: GlobalStateModel) {
    return state.language;
  }
  @Selector()
  static getBioSealUrl(state: GlobalStateModel) {
    return state.biosealUrl;
  }
  @Selector()
  static getFaceUrl(state: GlobalStateModel) {
    return state.faceUrl;
  }
  @Selector()
  static getToken(state: GlobalStateModel) {
    return state.token;
  }
  @Selector()
  static getVerificationUrl(state: GlobalStateModel) {
    return state.verificationUrl;
  }
  @Selector()
  static isMobile(state: GlobalStateModel) {
    return state.isMobile;
  }
  @Selector()
  static getUseCase(state: GlobalStateModel) {
    return state.useCase;
  }
  @Selector()
  static getPhotoDisplay(state: GlobalStateModel) {
    return state.photoDisplay;
  }
  @Action(setDefaultGlobal)
  setDefaultGlobalState({
    getState,
    patchState,
  }: StateContext<GlobalStateModel>) {
    const state = getState();
    patchState({
      ...state,
      step: STEP.USE_CASE_MENU,
      contentType: true,
      barcodeType: "BioSeal",
      isPersonalDataLoaded: false,
      isDocumentDataLoaded: false,
      isMobile: this.deviceService.isMobile(),
    });
  }
  @Action(setPrimaryColor)
  setPrimaryColor(
    { getState, patchState }: StateContext<GlobalStateModel>,
    { payload }: setPrimaryColor
  ) {
    const state = getState();
    patchState({
      ...state,
      primaryColor: payload,
    });
  }
  @Action(setSecondaryColor)
  setSecondaryColor(
    { getState, patchState }: StateContext<GlobalStateModel>,
    { payload }: setSecondaryColor
  ) {
    const state = getState();
    patchState({
      ...state,
      secondaryColor: payload,
    });
  }

  @Action(setTertiaryColor)
  setTertiaryColor(
    { getState, patchState }: StateContext<GlobalStateModel>,
    { payload }: setTertiaryColor
  ) {
    const state = getState();
    patchState({
      ...state,
      tertiaryColor: payload,
    });
  }

  @Action(setBarcodeType)
  setBarcodeType(
    { getState, patchState }: StateContext<GlobalStateModel>,
    { payload }: setBarcodeType
  ) {
    const state = getState();
    patchState({ ...state, barcodeType: payload });
  }

  @Action(setLanguage)
  setLanguage(
    { getState, patchState }: StateContext<GlobalStateModel>,
    { payload }: setLanguage
  ) {
    const state = getState();
    patchState({
      ...state,
      language: payload,
    });
  }
  @Action(setSTEP)
  setStep(
    { getState, patchState }: StateContext<GlobalStateModel>,
    { payload }: setSTEP
  ) {
    const state = getState();
    patchState({
      ...state,
      step: payload,
    });
  }

  @Action(setContentType)
  setContentType(
    { getState, patchState }: StateContext<GlobalStateModel>,
    { payload }: setContentType
  ) {
    const state = getState();
    patchState({
      ...state,
      contentType: payload,
    });
  }

  @Action(setPhotoDisplay)
  setPhotoDisplay(
    { getState, patchState }: StateContext<GlobalStateModel>,
    { payload }: setPhotoDisplay
  ) {
    const state = getState();
    patchState({
      ...state,
      photoDisplay: payload
    });
  }

  @Action(incrementStep)
  IncrementSteps({ getState, patchState }: StateContext<GlobalStateModel>) {
    const state = getState();
    switch (state.useCase) {
      case USECASE.GENERIC:
        if (state.step === STEP.USER_FORM_DOCUMENT) {
          if (!state.contentType) {
            patchState({
              ...state,
              step: state.step + 2,
            });
          } else {
            patchState({
              ...state,
              step: state.step + 1,
            });
          }
        } else {
          patchState({
            ...state,
            step: state.step + 1,
          });
        }
        break;
      case USECASE.VACCINATION:
        patchState({
          ...state,
          step: state.step + 1,
        });
        break;
      case USECASE.COVID_TEST:
        patchState({
          ...state,
          step: state.step + 1
        });
        break;
      case USECASE.ACCREDITATION:
        patchState({
          ...state,
          step: state.step + 1
        });
        break;
      default:
        patchState({
          ...state,
          step: state.step + 1,
        });
        break;
    }
  }

  @Action(decrementStep)
  decrementStep({ getState, patchState }: StateContext<GlobalStateModel>) {
    const state = getState();
    switch (state.useCase) {
      case USECASE.GENERIC:
        if (state.step == STEP.BIOSEAL_DISPLAY && !state.contentType) {
          patchState({
            ...state,
            step: state.step - 2,
          });
        } else {
          patchState({
            ...state,
            step: state.step - 1,
          });
        }
        break;
      case USECASE.VACCINATION:
        patchState({
          ...state,
          step: state.step - 1,
        });
        break;
      case USECASE.ACCREDITATION:
        patchState({
          ...state,
          step: state.step - 1,
        });
        break;
      default:
        patchState({
          ...state,
          step: state.step - 1,
        });
    }
  }

  @Action(setToken)
  setToken(
    { getState, patchState }: StateContext<GlobalStateModel>,
    { payload }: setToken
  ) {
    const state = getState();
    patchState({
      ...state,
      token: payload,
    });
  }
  @Action(setBioSealUrl)
  setBioSealUrl(
    { getState, patchState }: StateContext<GlobalStateModel>,
    { payload }: setBioSealUrl
  ) {
    const state = getState();
    patchState({
      ...state,
      biosealUrl: payload,
    });
  }
  @Action(setFaceUrl)
  setFaceUrl(
    { getState, patchState }: StateContext<GlobalStateModel>,
    { payload }: setFaceUrl
  ) {
    const state = getState();
    patchState({
      ...state,
      faceUrl: payload,
    });
  }
  @Action(setVerificationUrl)
  setVerificationUrl(
    { getState, patchState }: StateContext<GlobalStateModel>,
    { payload }: setVerificationUrl
  ) {
    const state = getState();
    patchState({
      ...state,
      verificationUrl: payload,
    });
  }

  @Action(setupUseCase)
  setUseCase(
    { getState, patchState }: StateContext<GlobalStateModel>,
    { payload }: setupUseCase
  ) {
    const state = getState();
    patchState({
      ...state,
      useCase: payload,
    });
  }
}
